import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {EMPTY_FAVORITE, EMPTY_USER} from '@models/empty';
import {Favorite} from '@models/favorite';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {AuthenticationService} from '@services/authentification.service';
import {MatDialog} from '@angular/material/dialog';
import {UntypedFormControl} from '@angular/forms';
import {City} from '@models/city';
import {WidgetDirective} from '@components/widget/widget.directive';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '@services/alert.service';
import {TrackingService} from '@services/tracking.service';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-config-project-tools',
  templateUrl: './config-project-tools.component.html',
  styleUrls: ['./config-project-tools.component.scss']
})
export class ConfigProjectToolsComponent implements OnInit {

    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;

    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    params;
    displayError = false;
    cityControl = new UntypedFormControl();
    cities: City[] = [];
    // Dernier nom valide : choisir une option écrit l'objet ville dans ad_city.name (ngModel)
    private cityName = '';

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        private adService: AdService,
        private alertService: AlertService,
        public authenticationService: AuthenticationService,
        public cityService: CityService,
        public trackingService: TrackingService) {
    }

    ngOnInit() {
        document.body.style.overflowY = "hidden";
        this.favorite = this.adService.getEmptyFavorite();
        this.route.queryParams
            .subscribe(params => {
                    if (Object.keys(params).length !== 0) {
                        this.favorite.price = params.price;
                        this.favorite.square = params.square;
                        if (params.city) {
                            this.cityService.getCity(params.city).subscribe(c => {
                                if (!c) {
                                    return;
                                }
                                this.favorite.ad_city = c;
                                this.cityName = c.name;
                                this.saveSimulation();
                            });
                        }
                        this.displayError = true;
                    }
                }
            );

        this.cityControl.valueChanges
            .pipe(
                startWith(''),
                debounceTime(500),
                // tap(() => this.isLoading = true),
                switchMap(value => this.cityService.searchCommune(this.favorite.ad_city.name))
                // .pipe(finalize(() => this.isLoading = false))
            )
            .subscribe(d => {
                $('.citySpinner').hide();
                this.cities = d;
            });
    }

    launchSimulation() {
        this.displayError = true;
        if (this.favorite.ad_city.zip_code !== '' && this.favorite.price > 0) {
            this.saveSimulation();
        }
    }

    saveSimulation() {
        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite.created_at = null;
        this.favorite.ad.fpb = null;
        this.favorite = this.adService.fillUSerInfo(this.favorite);
        this.adService.addAnnonce(this.favorite).subscribe(favorite => {
            this.router.navigate(['/app/annonces', favorite.id]);
        }, error => {
            console.log('Error');
            console.log(error);
            this.alertService.error('Une erreur est survenue. Veuillez vérifier les données saisies.');
        });
    }

    edit(event, fields = '') {
        if (fields === 'price') {
            // Set to null to calculate it
            this.favorite.notary_price = null;
            if (this.authenticationService.currentUser.pro_plan == 'oikos') {
                this.favorite.other_fees = null;
                this.favorite.other_fees_work = null;
                this.favorite.building_insurance = null;
            }
        }
        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);
    }

    changeCity(value) {
        this.cityService.getCity(value.city_code).subscribe(c => {
            if (!c) {
                this.favorite.ad_city.name = this.cityName;
                return;
            }
            this.favorite.ad_city = c;
            this.cityName = c.name;
        });
    }
}
